<template>
  <div class style="width: 1200px;
  margin: 0 auto;">
    <div class="welcome">欢迎注册</div>
    <div style="margin-top: 60px;">
      <el-steps :active="isActive" align-center process-status="wait" class="el-title">
        <el-step title="验证手机">
          <i class="phone-icon-active" slot="icon"></i>
        </el-step>
        <el-step title="设置账号">
          <i class="admin-icon" slot="icon" :class="isActive==1?'admin-icon':'admin-icon-active'"></i>
        </el-step>
        <el-step title="完成注册">
          <i class="ok-icon" slot="icon" :class="isActive==3?'ok-icon-active':'ok-icon'"></i>
        </el-step>
      </el-steps>
    </div>
    <div v-show="isActive==1">
      <div class="register-now-auto">
        <div
          style="margin: 0 auto;width: 870px;background: #F9F9F9;border: 1px solid #EAEAEA;padding-left: 45px;padding-top: 30px;padding-bottom: 30px;"
        >
          <div class="register-text-hint">▪ 如果您是贵公司第一个注册员工，您在完成注册后，可在系统内邀请您的同事一起加入中航运捷运进行协作</div>
          <div class="register-text-hint">▪ 如果您不是贵公司第一个注册员工，您可以要求注册同事帮您创建账号，这样你们同属一家公司，方便后续合作订单</div>
        </div>
      </div>
      <div class="register-check-form1">
        <div class style="margin-left:180px;">
          <el-form :model="ruleForm1" :rules="rules1" ref="ruleForm1" label-position="left">
            <el-form-item label="手机号码" label-width="100px" prop="phone" class="register-item">
              <el-col :span="14">
                <el-input
                  class="register-input"
                  type="text"
                  v-model="ruleForm1.phone"
                  autocomplete="off"
                  placeholder="请输入手机号码"
                  autosize
                  style
                ></el-input>
                <span class="register-require">*</span>
              </el-col>
              <el-col :span="4"></el-col>
            </el-form-item>
            <el-form-item label="图片验证码" label-width="100px" prop="imageCode" class="register-item">
              <el-col :span="14">
                <el-input
                  class="register-input"
                  type="text"
                  v-model="ruleForm1.imageCode"
                  autocomplete="off"
                  placeholder="请输入图片验证码"
                ></el-input>
                <span class="register-require">*</span>
              </el-col>
              <el-col :span="5" style="padding-left:10px;">
                <Sidentify :identifyCode="identifyCode" style="line-height: normal;"></Sidentify>
              </el-col>
              <el-col :span="5" style="padding-left:30px;">
                <el-button type="text" style="color: #00418E;" @click="refreshCode">看不清，换一张</el-button>
              </el-col>
            </el-form-item>
            <el-form-item
              label="短信验证码"
              label-width="100px"
              prop="messageCode"
              class="register-item"
            >
              <el-col :span="14">
                <el-input
                  class="register-input"
                  v-model="ruleForm1.messageCode"
                  placeholder="请输入短信验证码"
                ></el-input>
                <span class="register-require">*</span>
              </el-col>
              <el-col :span="4">
                <button
                  type="text"
                  class="message-btn"
                  @click.prevent="getMessageCode('ruleForm1')"
                  v-text="messageBtn"
                  :disabled="timer>0"
                >0</button>
              </el-col>
            </el-form-item>
            <el-form-item>
              <el-col :span="16">
                <el-button class="register-form-submit" @click="submitVerfiyPhone('ruleForm1')">提交</el-button>
              </el-col>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <div v-show="isActive==2">
      <div class="register-check-form2">
        <el-form :model="ruleForm2" :rules="rules2" ref="ruleForm2" label-position="left">
          <el-form-item label="输入密码" label-width="100px" prop="passwd" class="register-item">
            <el-col :span="24">
              <el-input
                class="register-input"
                type="password"
                v-model="ruleForm2.passwd"
                autocomplete="off"
                placeholder="请输入密码"
              ></el-input>
              <span class="register-requires">*</span>
            </el-col>
          </el-form-item>
          <el-form-item label="确认密码" label-width="100px" prop="checkPasswd" class="register-item">
            <el-col :span="24">
              <el-input
                class="register-input"
                type="password"
                v-model="ruleForm2.checkPasswd"
                autocomplete="off"
                placeholder="请输入确认密码"
              ></el-input>
              <span class="register-requires">*</span>
            </el-col>
          </el-form-item>
          <el-form-item label="设置邮箱" label-width="100px" prop="exmail" class="register-item">
            <el-col :span="24">
              <el-input
                class="register-input"
                type="text"
                v-model="ruleForm2.exmail"
                placeholder="请输入邮箱"
              ></el-input>
              <span class="register-requires">*</span>
            </el-col>
          </el-form-item>
          <el-form-item label="姓名" label-width="100px" prop="compellation" class="register-item">
            <el-col :span="24">
              <el-input
                class="register-input"
                type="text"
                v-model="ruleForm2.compellation"
                placeholder="请输入姓名"
              ></el-input>
              <span class="register-requires">*</span>
            </el-col>
          </el-form-item>
          <el-form-item label="公司" label-width="100px" prop="company" class="register-item">
            <el-col :span="24">
              <el-input
                class="register-input"
                type="text"
                v-model="ruleForm2.company"
                placeholder="请输入公司"
              ></el-input>
              <span class="register-requires">*</span>
              <div class="register-hint" style="width: 300px;">{{companyhint}}</div>
            </el-col>
          </el-form-item>
          <el-form-item>
            <el-col :span="24">
              <el-button class="register-form-submit" @click="submitSetName('ruleForm2')">提交</el-button>
            </el-col>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div v-show="isActive==3">
      <div class="register-now-auto">
        <div
          style="margin: 0 auto;width: 870px;background: #F9F9F9;border: 1px solid #EAEAEA;padding-left: 45px;padding-top: 30px;padding-bottom: 30px;"
        >
          <div
            class="register-text-hint"
            v-show="companyType=='new'"
          >▪ 您已完成EIMSKIP的账号注册，我们的工作人员会在2个工作日内联系您进行账户认证，认证完成后您可在平台进行下单</div>
          <div
            class="register-text-hint"
            v-show="companyType=='old'"
          >▪ 您已完成EIMSKIP的账号注册，由于您的公司在平台已存在，您的加入申请需要经过您同事的审批才能完成</div>
          <div class="register-text-hint">▪ 注册完成后您可以开始体验平台为您提供的各种服务功能</div>
        </div>
        <div class="register-now-btn">
          <el-col :span="24">
            <el-button class="register-now" @click="nowExperience()">进入物流管家开始体验</el-button>
          </el-col>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Sidentify from "../components/Sidentify.vue";
export default {
  components: { Sidentify },
  data() {
    //手机号码验证
    var validatePhone = (rule, value, callback) => {
      var that = this;
      var regPhone = /^1[3456789]\d{9}$/; //手机号校验正则
      if (value === "") {
        callback(new Error("请输入手机号码"));
      } else if (!regPhone.test(value)) {
        callback(new Error("手机号码格式有误，请输入正确的手机号码"));
      } else {
        let params = {};
        params.userAccountName = that.ruleForm1.phone;
        let response = that.apiService
          .get("/sinoslog-ops-service/user/mobilePhone", { params })
          .then(res => {
            if (res.data.data.data == "已注册") {
              callback(new Error("手机号码已注册"));
            } else {
              callback();
            }
          });
      }
    };
    //图片验证码
    var validateImageCode = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入图片验证码"));
      } else if (
        value.toLocaleLowerCase() != this.identifyCode.toLocaleLowerCase()
      ) {
        callback(new Error("输入的图片验证码错误"));
      } else {
        callback();
      }
    };
    //短信验证码
    var checkMessageCode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("短信验证码为空"));
      } else if (value.toString().length !== 6) {
        callback(new Error("请输入长度为4位验证码"));
      } else {
        callback();
      }
    };
    //设置密码
    var validatePasswd = (rule, value, callback) => {
      var regPassword = /^.*(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])\w{5,30}/;
      if (!value) {
        callback(new Error("请输入密码"));
      } else if (!regPassword.test(value)) {
        callback(new Error("密码必须包含6到30位大小写字母、数字"));
      } else {
        callback();
      }
    };
    //校验密码
    var validateCheckPasswd = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入确认密码"));
      } else if (value !== this.ruleForm2.passwd) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    //邮箱
    var validateExmail = (rule, value, callback) => {
      //邮箱校验正则
      var regExmail = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;
      if (!value) {
        callback(new Error("请输入邮箱"));
      } else if (!regExmail.test(value)) {
        callback(new Error("邮箱格式有误，请输入正确邮箱"));
      } else {
        callback();
      }
    };
    //姓名
    var validateName = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入姓名"));
      } else {
        callback();
      }
    };
    //公司
    let validateCompany = (rule, value, callback) => {
      let that = this;
      that.companyhint = "";
      if (!value) {
        callback(new Error("请输入公司"));
      } else {
        let params = {};
        params.customerName = that.ruleForm2.company;
        let response = that.apiService
          .get("/sinoslog-ops-service/user/customerName", { params })
          .then(res => {
            if (res.data.data.data) {
              if (res.data.data.data == "未注册") {
                //是新公司
                that.companyhint = "";
                that.companyType = "new";
              } else if (res.data.data.data == "已注册") {
                that.userType = 2;
                that.administrator();
                //不是新公司
              }
            }
            callback();
          });
      }
    };
    return {
      userType: 1, //用户类型
      isActive: 1, //默认显示验证手机步骤
      messageBtn: "发送短信验证码",
      timer: 0, //设置定时器初始值为0
      identifyCodes:
        "ABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890abcdefghijklmnopqrstuvwxyz",
      identifyCode: "", //图片验证码
      companyhint: "", //公司校验提示
      companyType: "", //公司类型
      ruleForm1: {
        phone: "", //手机号码
        imageCode: "", //图片验证码
        messageCode: "" //短信验证码
      },
      ruleForm2: {
        passwd: "", //密码
        checkPasswd: "", //校验密码
        exmail: "", //邮箱
        compellation: "", //姓名
        company: "" //公司
      },
      rules1: {
        phone: [{ validator: validatePhone, trigger: "blur" }],
        imageCode: [{ validator: validateImageCode, trigger: "blur" }],
        messageCode: [{ validator: checkMessageCode, trigger: "blur" }]
      },
      rules2: {
        passwd: [{ validator: validatePasswd, trigger: "blur" }],
        checkPasswd: [{ validator: validateCheckPasswd, trigger: "blur" }],
        exmail: [{ validator: validateExmail, trigger: "blur" }],
        compellation: [{ validator: validateName, trigger: "blur" }],
        company: [{ validator: validateCompany, trigger: "blur" }]
      }
    };
  },
  mounted() {
    this.identifyCode = "";
    this.makeCode(this.identifyCodes, 4);
  },
  methods: {
    //管理员数量
    async administrator() {
      let that = this;
      let params = {};
      params.customerName = that.ruleForm2.company;
      let response = await that.apiService
        .get("/sinoslog-ops-service/user/queryAdminByCustomerName", {
          params
        })
        .then(res => {
          if (res.data.data.data == 0) {
            that.companyhint = "公司已存在，但无管理员，请联系客服审批加入";
            that.companyType = "old";
          } else {
            //不是新公司
            that.companyhint = "公司已存在，需要管理员审批加入";
            that.companyType = "old";
          }
        });
    },
    //手机验证提交
    submitVerfiyPhone(formName) {
      var that = this;
      that.$refs[formName].validate(valid => {
        if (valid) {
          let params = {};
          params.mobilePhone = that.ruleForm1.phone;
          params.smsCode = that.ruleForm1.messageCode;
          let response = that.apiService
            .get("/sinoslog-ops-service/sendMessage/checkSmsCode", { params })
            .then(res => {
              if (res.data.data.code == "failed") {
                that.$message({
                  showClose: true,
                  customClass: "register-bg",
                  message: "验证码已失效",
                  type: "error",
                  offset: 300
                });
              } else if (res.data.data.code == "error") {
                that.$message({
                  showClose: true,
                  customClass: "register-bg",
                  message: "验证码不一致",
                  type: "error",
                  offset: 300
                });
              } else {
                that.isActive = 2;
              }
            });
        } else {
          return false;
        }
      });
    },
    //设置账号提交
    submitSetName(formName) {
      var that = this;
      that.$refs[formName].validate(valid => {
        if (valid) {
          let data = {};
          data.userAccountName = that.ruleForm1.phone;
          data.password = that.ruleForm2.passwd;
          data.userNameCn = that.ruleForm2.compellation;
          data.registerModel = that.userType;
          data.company = that.ruleForm2.company;
          data.mobilePhone = that.ruleForm1.phone;
          data.email = that.ruleForm2.exmail;
          data.userDomainCode = "SSLCP";
          let response = that.apiService
            .post("/sinoslog-ops-service/user/register", data)
            .then(res => {
              if (res.data.data.msg !== "success") {
                that.$message({
                  showClose: true,
                  customClass: "register-bg",
                  message: "注册失败",
                  type: "error",
                  offset: 300
                });
              } else {
                that.isActive = 3;
              }
            });
        } else {
          return false;
        }
      });
    },
    //获取短信验证码
    getMessageCode(formName) {
      var that = this;
      that.$refs[formName].validateField(["phone"], valid => {
        if (!valid) {
          that.timer = 60; //设定重新获取验证码为60秒
          var setInterObj = setInterval(function() {
            if (that.timer > 0) {
              that.messageBtn = that.timer + "s后重新获取";
              that.timer--;
            } else {
              that.messageBtn = "发送短信验证码";
              clearInterval(setInterObj);
            }
          }, 1000);
          let params = {};
          params.mobilePhone = that.ruleForm1.phone;
          params.templateType = "SMS_201480444";
          let response = that.apiService
            .get("/sinoslog-ops-service/sendMessage/smsCode", { params })
            .then(res => {
              if (res.data.data.msg == "error") {
                that.$message({
                  showClose: true,
                  customClass: "register-bg",
                  message: "获取验证码失败",
                  type: "error",
                  offset: 300
                });
              }
            });
        }
      });
    },
    //进入物流管家立即体验按钮
    nowExperience() {
      var that = this;
      let data = {};
      data.userDomainCode = "SSLCP";
      data.userAccountName = that.ruleForm1.phone;
      data.password = that.ruleForm2.passwd;
      let response = that.apiService
        .post("/sinoslog-ops-service/user/login", data)
        .then(res => {
          if (res.data.data.data && res.data.data.msg) {
            that.$cookies.set("username", that.ruleForm1.phone, "7d");
            that.$cookies.set("password", that.ruleForm2.passwd, "7d");
            localStorage.setItem(
              "userInfo",
              JSON.stringify(res.data.data.data)
            ); //用户信息
            that.$router.push({ name: "Home" });
          } else {
            that.$message({
              showClose: true,
              customClass: "register-bg",
              message: res.data.errorMessages[0],
              type: "error",
              offset: 300
            });
          }
        });
    },
    //生成随机数
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    //刷新图片验证码
    refreshCode() {
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },
    //制作随机码
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[
          this.randomNum(0, this.identifyCodes.length)
        ];
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.register-hint {
  color: rgb(0, 65, 142);
  font-size: 12px;
  text-align: left;
}
.register-text-hint {
  text-align: left;
  color: #333333;
}
.register-now-btn {
  margin: 40px 0 300px 0;
}
.register-now-auto {
  max-width: 1200px !important;
  margin: 0 auto;
  font-size: 14px;
  padding: 30px 0;
}

.register-check-form1 {
  max-width: 750px;
  margin: 0 auto 60px auto;
}
.register-check-form2 {
  max-width: 400px;
  margin: 40px auto 40px auto;
}
</style>



// WEBPACK FOOTER //
// src/views/Register.vue